//@flow

import SectionTitle from "../components/sectionTitle";
import DeleteInsuredPerson from "./deleteInsuredPerson";

type Props = {
  insuredPersonId: string;
};

const DangerZone = (props: Props) => {
  const { insuredPersonId } = props;

  return (
    <div>
      <SectionTitle title="Gevarenzone" />
      <DeleteInsuredPerson insuredPersonId={insuredPersonId} />
    </div>
  );
};

export default DangerZone;
